export function set_interval(cb: () => boolean, timeout: number) {
  const again = () => {
    if (cb()) {
      setTimeout(again, timeout)
    }
  }
  setTimeout(again, timeout)
}

export function uuid() {
  return crypto.randomUUID()
}

export function update_display(id: string, value: string) {
  const el = document.getElementById(id)
  if (el) {
    el.innerHTML = value
    return true
  } else {
    return false
  }
}
